export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20golden%20light%20streaks%20and%20subtle%20film%20grain%20texture%2C%20deep%20charcoal%20tones%2C%20atmospheric%20theater%20vibe%2C%20minimal%20elegant%20movie%20poster%20aesthetic%2C%20soft%20glow%20highlights%2C%20no%20text%2C%20abstract%20art%20style&width=1600&height=900&seq=hero-bg-chunse-01&orientation=landscape"
          alt="春色影视背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 max-w-[1440px] mx-auto py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/15 text-primary-400 text-xs md:text-sm font-medium mb-5 tracking-wide">
              不缓冲 · 秒开播放
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-50 leading-tight mb-4">
              春色影视 — 高清免费在线观影平台
            </h1>

            <p className="text-base md:text-lg text-primary-400/90 font-medium mb-5">
              电影电视剧全集实时更新，流畅不卡顿
            </p>

            <p className="text-sm md:text-base text-foreground-300 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              春色影视致力于为观众提供极致的在线观影体验。平台涵盖电影、电视剧、综艺、动漫等全品类内容，每日实时更新最新资源。不缓冲技术确保秒开播放，高清画质搭配流畅体验，让每一次观影都成为享受。无论热门大片还是经典回顾，春色影视始终免费不收费，用心打造属于你的私人影院。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-400">200+</div>
                <div className="text-xs text-foreground-400 mt-1">每日更新 / 部</div>
              </div>
              <div className="w-px h-10 bg-background-300/40"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-400">1080P</div>
                <div className="text-xs text-foreground-400 mt-1">高清画质</div>
              </div>
              <div className="w-px h-10 bg-background-300/40"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-secondary-400">全平台</div>
                <div className="text-xs text-foreground-400 mt-1">多端同步观看</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观影
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-md border border-foreground-300/30 text-foreground-300 font-medium text-sm hover:border-primary-400/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                浏览片库
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative rounded-lg overflow-hidden aspect-[4/3] bg-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20collage%20of%20warm%20toned%20film%20scenes%2C%20movie%20reels%20and%20streaming%20visual%20metaphor%2C%20dark%20atmospheric%20background%20with%20golden%20light%20accents%2C%20modern%20digital%20entertainment%20aesthetic%2C%20film%20strip%20elements%2C%20no%20text%2C%20artistic%20composition&width=800&height=600&seq=hero-visual-chunse-01&orientation=landscape"
                alt="春色影视主视觉 — 电影电视剧在线观看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent"></div>

              <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2">
                <span className="px-2.5 py-1 rounded-full bg-background-950/70 text-xs text-primary-400 font-medium backdrop-blur-sm">
                  <i className="ri-fire-line mr-1"></i>热播中
                </span>
                <span className="px-2.5 py-1 rounded-full bg-background-950/70 text-xs text-foreground-300 font-medium backdrop-blur-sm">
                  每日更新
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}